var _style, _circle, _circle2, _path, _path2, _circle3, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReddiSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:red}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 451,
    cy: 450,
    r: 444
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 451,
    cy: 449.7,
    r: 432.1,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M689.9 336.5v33.7l53-26.7v-32.3zm53.5 9.7v30l48.9-30.9v-32.7zm-35.5 65.1s68.7-18.9 100.5-53v39.2s-18.9 18.9-30.4 20.3c-11.5 1.4-92.7 1.8-92.7 1.8l22.6-8.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M637.3 448.2H665V581h-27.7z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 651.2,
    cy: 409.4,
    r: 16.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.4 446.3c-33.2 0-50.3 12-58.1 20.3v-20.3s-26.7-2.3-26.7-.9v137.9h26.7v-71.9c14.3-31.8 47-35.5 47-35.5h128.2v-29.5c-1.3.4-15.6-.1-117.1-.1zm117.2 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.7 502.6H260v25.8h-79.3zm0 54.4h118.5v25.8H180.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M541.4 470.8c-25.8 0-46.6 21.2-46.6 46.6 0 25.4 21.2 46.6 46.6 46.6 25.4 0 46.6-21.2 46.6-46.6 0-25.4-20.8-46.6-46.6-46.6z",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M612.4 504.9V395.6h-27.2v64.6c-12-9.2-27.2-15.2-43.8-15.2-39.7 0-71.9 32.3-71.9 71.9s32.3 71.9 71.9 71.9c35.5 0 65-25.8 71-59.5v-24.4zm-71 59.5c-25.8 0-46.6-21.2-46.6-46.6 0-25.4 21.2-46.6 46.6-46.6 25.4 0 46.6 21.2 46.6 46.6 0 25.4-20.8 46.6-46.6 46.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.2 504.9V395.6H427v64.6c-12-9.2-27.2-15.2-43.8-15.2-39.7 0-71.9 32.3-71.9 71.9s32.3 71.9 71.9 71.9c35.5 0 65-25.8 71-59.5v-24.4zm-71 59.5c-25.8 0-46.6-21.2-46.6-46.6 0-25.4 21.2-46.6 46.6-46.6s46.6 20.8 46.6 46.6-20.8 46.6-46.6 46.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddiSmall);
export default __webpack_public_path__ + "static/media/reddi_small.1ce3b2685082ed79defab6f5a883ffe5.svg";
export { ForwardRef as ReactComponent };